import EfImg from 'elem/ui/ef-img';
import styles from './index.module.scss';
import { RuleTabModuleIdEnum } from '../Tab';

const FirstKv = ({ data }: { data: any }) => {
    return (
        <div className={styles.firstKv} id={RuleTabModuleIdEnum.Overview}>
            <EfImg className="img" pc={data.pc} h5={data.h5} />
            <div className="mask">
                <div className="text-container">
                    <h1 className="title">{data.title}</h1>
                    <p className="desc">{data.desc}</p>
                </div>
            </div>
        </div>
    );
};

export default FirstKv;
